'use strict';

angular.module('impactx.attachments').directive('ixAttachments', attachments);

attachments.$inject = ['$timeout'];

function attachments($timeout) {

    return {
        scope:
        {
            attachments: "=",
            dropzoneId: "@",
            selectItemMessage: "@",
            fileIcon: "@",
            accept: "@",
            readOnly: "=",
            isMediaEntry: "=",
            purposePopup: "=",
            hasTemplateOption: "@",
            templateLabel: "@",
            hasFixedOption: "@",
            fixedLabel: "@",
            hasVisibleForSupplierOption: "@",
            visibleForSupplierLabel: "@",
            visibilityClassifier1Label: "@",
            errorList: "=",
            notFixedAndTermsError: "@",
            showViewPosInput: "=",
            hideNoEntriesLabel: "=",
            singleFile: "=",
            streamingUpload: "@"
        },
        controller: "AttachmentsCtrl",
        controllerAs: 'attachmentsCtrl',
        link: link,
        restrict: 'E',
        templateUrl: 'shared/attachments/templates/attachments.tmpl.html'
    };

    function link(scope, element, attrs, ctrl) {
        var formController = element.controller('form');
        if(formController) {
            scope.formController = formController;
        }

        var dragCounter = 0;

        $timeout(function()
        {
            angular.element(document.querySelector('#fileInput' + scope.dropzoneId)).on('change', ctrl.handleFileSelect);
        }, 0);

        element.on('drop', function (e) {
            angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            e.preventDefault();
            var file = e.originalEvent.dataTransfer.files[0];
            ctrl.handleFile(e, file);
            dragCounter = 0;
        });

        element.on('dragover', function (e) {
            e.originalEvent.dataTransfer.dropEffect = "copy";
            e.preventDefault();
        });

        element.on('dragenter', function (e) {
            dragCounter++;
            if (dragCounter == 1)
            {
                angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', 'rgba(229, 229, 229, .5)');
            }
            e.originalEvent.dataTransfer.dropEffect = "copy";
            e.preventDefault();
        });

        element.on('dragleave', function (e) {
            dragCounter--;
            if (dragCounter <= 0)
            {
                angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            }
            e.originalEvent.dataTransfer.dropEffect = "none";
            e.preventDefault();
        });

        element.on('dragend', function (e) {
            angular.element(element[0].getElementsByClassName("dropzone")).css('background-color', '');
            e.originalEvent.dataTransfer.dropEffect = "none";
            e.preventDefault();
            dragCounter = 0;
        });
    }
}